import gql from "graphql-tag";

// Nombre de cada segmentación en la empresa del token (backend 127652d2 o
// posterior). Siempre trae 8 filas, una por id de SEGMENTACIONES, con lo propio
// de la empresa encima de los defaults; la empresa sale del token, por eso no
// lleva variables. Lo arma utils/terminos.js y lo carga el store "terminos".
// La operación se llama igual que el campo raíz porque exQue devuelve
// data[<nombre de la operación>].
export const GET_PALABRAS_EMPRESA = gql`
  query GetPalabrasEmpresas {
    GetPalabrasEmpresas {
      id_segmentacion
      singular
      plural
      genero
      el
      un
    }
  }
`;
